<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
          <b-card>
            <div slot="header">
              <strong>{{ $t("messages.applicationComplete") }}</strong>
            </div>
            <p>{{ $t("messages.contactSoon") }}</p>
          </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { DateTime } from 'luxon';
import { mapActions, mapGetters } from 'vuex';
import VueNotifications from 'vue-notifications';

export default {
  name: 'privacy',
  data() {
      return {
        termsModal: false,
        privacyModal: false,
        termsAgreed: false,
      }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: 'Success',
      message: 'Successfully saved.'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: 'Oops',
      message: 'Error.'
    }
  },
  methods: {
    ...mapActions({
        patchCreditApp: 'creditapps/patchCreditApp',
    }),
  }
}
</script>
